const Timelinedata=[

  { time: '9 AM', event: 'ENTRY + REGISTRATION' },
  { time: '9:45 AM', event: 'EVENT STARTS' },
  { time: '10:15 AM - 10:45 AM',  event: 'INAUGURATION' },
  { time: '10:45 AM - 11:25 AM', event: 'SPEAKER 1' },
  { time: '11:25 AM - 12:05 PM',  event: 'SPEAKER 2' },
  { time: '12:05 PM - 12:20 PM', event: 'PERFORMANCE' },
  { time: '12:20 PM - 1:00 PM',  event: 'SPEAKER 3' },

  { time: '1:00 PM - 1:40 PM',  event: 'SPEAKER 4' },
  { time: '1:40 PM - 2:40 PM',  event: 'LUNCH' },
  { time: '2:40 PM - 3:10 PM',  event: 'PERFORMANCE' },
  { time: '3:10 PM - 3:50 PM',  event: 'SPEAKER 5' },
  { time: '3:50 PM - 4:30 PM',  event: 'SPEAKER 6' },
  { time: '4:30 PM - 4:45 PM',  event: 'PERFORMANCE' },
  { time: '4:45 PM - 5:25 PM', event: 'SPEAKER 7' },
  { time: '5:25 PM - 6:05 PM', event: 'SPEAKER 8' },
  { time: '6:05 PM - 6:30 PM',  event: 'PERFORMANCE' },
  { time: '6:30 PM - 7:00 PM',  event: 'VOTE OF THANKS' },
];
export default Timelinedata;
